// StoreInfoView.js
// import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import {
    DialogContent, DialogActions, Button,
    Grid,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import StoreIcon from '@mui/icons-material/Store';
import { AppStyle, AppWord } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { VzmPrint } from '../../common/VzmStyled';
import DraggableViewer from '../../common/DraggableViewer';
import { StoreInfoDictionary } from './StoreInfoDict';
import { useAuthorizationCheck } from '../../api/app-hook';

// background color in gradient style (light gray to white, then light gray)
const ViewContainer = styled(Box)({
    marginTop: 10
});

const InputMap = StoreInfoDictionary.inputMap;

/**
 * (STORE_INFO) 정보 상세보기
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-09-02 17:31:39 using DbdbTap
 */
export default function StoreInfoView({
    open,
    item,
    onRequestEdit,
    onClose
}) {
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();

    if(!open || !item) return null;
    const canEdit = checkAuth(authTableTree.tree.pr_store_info_edit);

    return(
        <DraggableViewer open={open} onClose={onClose} maxWidth='md'
            startIcon={<StoreIcon fontSize={AppWord.LARGE} />}
            title={`${item.storeName} 정보 상세보기`}
        >
            <DialogContent>
                <ViewContainer>
                    <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <VzmPrint label={InputMap.storeName.label} value={item.storeName} />
                        </Grid>
                        <Grid item xs={2}>
                            <VzmPrint label={InputMap.storeId.label} value={item.storeId} />
                        </Grid>
                        <Grid item xs={5}>
                            <VzmPrint label={InputMap.storeTypeName.label} value={item.storeTypeName} />
                        </Grid>

                        <Grid item xs={2}>
                        <VzmPrint label={InputMap.zipCd.label} value={item.zipCd} />
                        </Grid>
                        <Grid item xs={10}>
                            <VzmPrint label={InputMap.addr.label} value={item.addr} />
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.officeTelno.label} value={item.officeTelno} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.storeStaffName.label} value={item.storeStaffName} />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.secuTelno.label} value={item.secuTelno} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.secuStaffName.label} value={item.secuStaffName} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.totTelno.label} value={item.totTelno} />
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.useYn.label} value={item.useYn==='Y' ? '사용' :'사용중지'} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label='등록일' value={item.regDate} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label='등록자' value={item.regUserName} />
                        </Grid>
                    </Grid>
                            {/* <VzmPrint label={InputMap.fillRateYn.label} value={item.fillRateYn} /> */}
                    
                </ViewContainer>
            </DialogContent>
            <DialogActions>
                {
                    canEdit ?
                    <Button
                        onClick={()=>{onRequestEdit(item)}}
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        sx={{width: 120, marginRight: 1}}
                        startIcon={<EditIcon />}
                    >
                        편집
                    </Button>
                    : null
                }
                <Button onClick={onClose}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );

}